import React, { useEffect, useState } from "react";
import {
  Grid,
  Divider,
  Typography,
  CircularProgress,
  ButtonGroup,
  IconButton,
  Button,
  Checkbox,
  FormControl,
  FormGroup,
  FormControlLabel
} from "@material-ui/core";
import { UserPrivacyStyles } from "./UserPrivacyStyles";
import {
  GetLegalRGPD,
  PostLegalRGPD,
} from "../../services/LegalCallsService";
import {
  GetUtilitiesCorreosIdSubscriptionUserTycPrivacyUrls,
} from "../../services/UtilitiesCallsService";
import {
  GetMasterRgpd,
} from "../../services/MasterCallsService";
import { CorreosButton } from "../../components/CorreosButton/CorreosButton";
import { Alerts } from "../Alerts/Alerts";
import { Constants } from "../../commons/Constants";
import { checkIsNullUndefined, getErrorMessage } from "../../commons/Utils";
import { useTranslation } from "react-i18next";
import { CommonStyles } from "../../commons/CommonStyles";
import { CorreosIcon } from "../CommonComponents/CorreosIcon/CorreosIcon";
import { EnumPrivacyTyC, iconNames } from "../../commons/EnumsGeneral";


export function UserPrivacy() {
  const commonClasses = CommonStyles();
  const classes = UserPrivacyStyles();
  const { t } = useTranslation();

  const [userSignTyC, setUserSignTyC] = useState([]);
  const [circularPrivacyProgress, setCircularPrivacyProgress] =
    useState(false);
  const [originalUserTyC, setOriginalUserTyC] = useState([]);
  const [userTyC, setUserTyC] = useState([]);
  const [alert, setAlert] = useState({
    open: false,
    color: "",
    message: "",
  });
  const [checkAllRgps, setCheckAllRgps] = useState(false);


  useEffect(() => {
    getServices();
    getUserRgpd();
  }, []);

  const finishOperation = (color, message) => {
    setAlert({
      open: true,
      color,
      message,
    });
  };

  const getServices = () => {

    GetUtilitiesCorreosIdSubscriptionUserTycPrivacyUrls().then((response) => {
      if (response && !response.Status) {
        setUserSignTyC(response);
      } else {
        finishOperation("error", getErrorMessage(response, t));
      }
    });
  };

  const getUserRgpd = () => {
    setCircularPrivacyProgress(true);
    GetMasterRgpd().then((response) => {
      if (response && !response.Status) {
        GetLegalRGPD().then((respon) => {
          if (respon && !respon.Status) {
            let auxiliaryTerms = [];
            response.forEach((elem) => {
              let auxiliarRgpd = respon.filter((rgpd) => {
                return rgpd.idRgpd === elem.id;
              });
              elem.checked = auxiliarRgpd.length > 0 ? 1 : 2;
              auxiliaryTerms.push(elem);
            });
            checkAllChecked(auxiliaryTerms);
            let auxiliaryCloneTerms = JSON.parse(
              JSON.stringify(auxiliaryTerms)
            );
            setUserTyC(auxiliaryTerms);
            setOriginalUserTyC(auxiliaryCloneTerms);
            setCircularPrivacyProgress(false);
          } else {
            finishOperation("error", getErrorMessage(respon, t));
            setCircularPrivacyProgress(false);
          }
        });
      } else {
        finishOperation("error", getErrorMessage(response, t));
        setCircularPrivacyProgress(false);
      }
    });
  };

  const checkAllChecked = (auxiliaryTerms) => {
    let allChecked = auxiliaryTerms.filter((elem) => elem.checked !== 1);
    if (allChecked.length === 0) {
      setCheckAllRgps(true);
    }
  }

  const handleOptions = (value) => {
    let auxiliaryArray = JSON.parse(JSON.stringify(userTyC));
    auxiliaryArray.forEach((elem) => {
      if (elem.code + Constants.Si === value.currentTarget.name)
        elem.checked = 1;
      if (elem.code + Constants.No === value.currentTarget.name)
        elem.checked = 2;
    });
    setUserTyC(auxiliaryArray);
  };

  const handleCancel = () => {
    let auxiliaryArray = JSON.parse(JSON.stringify(originalUserTyC));
    setUserTyC(auxiliaryArray);
  };

  const handleAccept = () => {
    setCircularPrivacyProgress(true);
    let auxiliaryArray = [];
    userTyC.forEach((tyc) => {
      auxiliaryArray.push({
        idRgpd: tyc.id,
        accepted: tyc.checked === 1,
      });
    });
    PostLegalRGPD(auxiliaryArray).then((response) => {
      if (!response || response.Status) {
        finishOperation("error", getErrorMessage(response, t));
        setCircularPrivacyProgress(false);
      } else {
        finishOperation("success", t("privacySuccessChange"));
        getUserRgpd();
      }
    });
  };
  const handlePromotionsSelected = () => {
    let auxiliaryArray = JSON.parse(JSON.stringify(userTyC));
    if (checkAllRgps) {
      auxiliaryArray.forEach((elem) => {
        elem.checked = 2;
      });
      setUserTyC(auxiliaryArray);
      setCheckAllRgps(false);
    } else {
      auxiliaryArray.forEach((elem) => {
        elem.checked = 1;
      });
      setUserTyC(auxiliaryArray);
      setCheckAllRgps(true);
    }
  };

  const formatDate = (timeStamp) => {
    let auxText = "-";
    if (!checkIsNullUndefined(timeStamp)) {
      let date = timeStamp.split("T");
      let year = date[0].split("-")[0];
      let month = date[0].split("-")[1];
      let day = date[0].split("-")[2];
      auxText = (day + "/" + month + "/" + year);
    }
    return auxText;
  }

  const isEvenRow = (index) => {
    return index % 2 == 0;
  }



  const renderSignedInfo = (data, dateKey, urlKey) => {

    return data.map((item, index) => {
      if (!checkIsNullUndefined(index) && !checkIsNullUndefined(item[dateKey])) {
        return (
          <Grid container item xs={12} className={classes.tycInfoGrid}>
            <Grid item xs={12} md={11}>
              <span className={classes.signedText}>
                {`${t("privacySignedTyCPrivacy")} ${formatDate(item[dateKey])}`}
              </span>
            </Grid>
            <Grid item xs={12} md={1}>
              <IconButton
                classes={classes.buttonLink}
                edge="start"
                color="inherit"
                aria-label="menu"
                target="_blank"
                href={item[urlKey]}
                rel={"noopener noreferrer"}>

                <CorreosIcon
                  iconSelected={iconNames.link}
                  iconName="TyCLink Icon"
                  iconState="enabled"
                  iconScale={1.25} />
              </IconButton>
            </Grid>
          </Grid>
        );
      }
      return <Grid container item xs={12} className={classes.tycInfoGrid}>
        <Grid item xs={12} md={11} style={{ padding: "1.2em" }}>
          <span className={classes.signedText}>
            {t("privacySignedTyCPrivacyNoSigned")}
          </span>
        </Grid>
      </Grid>;
    });
  };

  const showSignedText = (service, option) => {
    return (
      <Grid item xs={4} style={{ display: "flex" }}>
        <Grid container>
          {option === "tyc"
            ? renderSignedInfo(service.tyc, "dateSignTyc", "urlTyc")
            : option === "privacy"
              ? renderSignedInfo(service.privacy, "dateSignPrivacy", "urlPrivacy")
              : null
          }
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid>
      <Alerts alert={alert} setAlert={setAlert}></Alerts>
      <Grid>
        <Grid container spacing={0} >
          {/*Tycs/Privacies */}
          <Grid container item xs={12}>
            <Grid container item xs={12} className={classes.rgpdTitle} style={{ marginBottom: "1em" }}>
              <Grid item xs={12} md={6} style={{ display: "flex" }}>
                <CorreosIcon iconSelected={iconNames.services} iconName="Legal Icon" iconState="basic" iconScale={2.5} />
                <Typography className={commonClasses.sectionTitleText}>
                  {t("privacyTyCLink")}
                </Typography>
              </Grid>
            </Grid>
            {/* Headers */}
            <Grid container item xs={12} style={{ marginBottom: "1em" }}>

              {["privacyMyServices", "privacyTyCLink", "privacyPrivacyLink"
              ].map((header, index) => (
                <Grid key={index} item md={4} xs={4} className={index === 0 ? classes.tycInfoHeader1 : classes.tycInfoHeader2}>
                  <Typography
                    variant="h6"
                    className={classes.titleColumn}>
                    {t(header)}
                  </Typography>
                </Grid>
              ))
              }
            </Grid>
            <Grid item md={12} xs={12}>
              {userSignTyC.map((service, index) => {
                return (
                  <Grid
                    container
                    className={isEvenRow(index) ? classes.evenRow : classes.oddRow}
                  >
                    <Grid item xs={4} className={classes.tycsApps}>
                      <span>{service.application} </span>
                    </Grid>
                    {showSignedText(service, "tyc")}
                    {showSignedText(service, "privacy")}
                  </Grid>
                );
              })}

            </Grid>
            <Grid item md={12} xs={12}>
              <Divider className={classes.categoryDivider}></Divider>
            </Grid>
          </Grid>

          {/* Rgpd title */}
          <Grid container item xs={12}>
            <Grid container item xs={12} spacing={1} className={classes.rgpdTitle}>
              <Grid item xs={12} md={6} style={{ display: "flex" }}>
                <CorreosIcon iconSelected={iconNames.lock} iconName="Lock Icon" iconState="basic" iconScale={2.5} />
                <Typography className={classes.rgpdTitleText}>
                  {t("privacyDataProtectionTitle")}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}
                justifyContent="flex-end" style={{ display: "flex" }}>

                <FormControl>
                  <FormGroup row >
                    <FormControlLabel
                      value="end"
                      control={<Checkbox color="primary" onClick={() => handlePromotionsSelected()} size="small" />}
                      label={<Typography className={classes.checkBoxLabel}>{checkAllRgps ? t("privacyDisableAllText") : t("privacyEnableAllText")}</Typography>}
                      labelPlacement="end"
                      style={{ marginRight: "0em" }}
                    />
                  </FormGroup>
                </FormControl>

              </Grid>
            </Grid>

            {/*Rgpds */}

            <Grid item md={12} xs={12}>
              {circularPrivacyProgress ? (
                <CircularProgress />
              ) : (


                <Grid container className={classes.cardContainer}>
                  <Grid item md={12} xs={12}>
                    <Grid container className={classes.cardFile}>
                    </Grid>
                    <Grid item md={12} xs={12} className={classes.rgpdTitle}>
                      <Grid>
                        {userTyC.map((element, index) => {
                          let nameSi = element.code + Constants.Si;
                          let nameNo = element.code + Constants.No;
                          return (
                            <Grid
                              item
                              xs={12}
                              style={{ marginBottom: "1em" }}
                            >
                              <Grid
                                container
                                alignItems="right"
                                spacing={0}
                              >
                                <Grid
                                  item
                                  xs={9}
                                  md={9}
                                  lg={9}
                                  className={
                                    classes.agreeConditionsTermsConsent
                                  }
                                >
                                  <span>{element.name}</span>
                                </Grid>
                                <Grid item xs={3} style={{ textAlign: "right" }}>
                                  <Typography className={classes.buttonLabel}>{element.checked === 1 ? "Activo" : "Inactivo"}</Typography>
                                  <ButtonGroup disableElevation >
                                    {[
                                      { value: 1, label: t("yes"), color: "primary", activeClass: classes.switchButton },
                                      { value: 2, label: t("no"), color: "secundary", activeClass: classes.switchButtonNoActive }
                                    ].map((btn) => (
                                      <Button
                                        key={btn.value}
                                        color={userTyC[index].checked === btn.value ? (btn.value === 1 ? "primary" : "secondary") : null}
                                        variant={userTyC[index].checked === btn.value ? "contained" : null}
                                        className={userTyC[index].checked === btn.value ? classes.switchButtonNoActive : classes.switchButton}
                                        name={btn.value === 1 ? nameSi : nameNo}
                                        onClick={(value) => handleOptions(value)}>
                                        {btn.label}
                                      </Button>
                                    ))}
                                  </ButtonGroup>
                                </Grid>
                              </Grid>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      sm={12}
                      xs={12}
                      style={{ marginTop: "5em", marginBottom: "5em" }}
                    >

                      {[
                        { label: "cancel", onClick: handleCancel, color: "secondary", style: { float: "left" } },
                        { label: "save", onClick: handleAccept, color: "primary", variant: "contained", style: { float: "right" } },
                      ].map((btn) => (
                        <CorreosButton
                          onClick={btn.onClick}
                          color={btn.color}
                          variant={btn.variant}
                          style={btn.style}
                        >
                          {t(btn.label)}
                        </CorreosButton>
                      ))}

                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>

          </Grid>
        </Grid>
      </Grid>
    </Grid >
  );
}